// Global JS for winchildtheme
// This is the src file, use 'npm run build' to compress to ../app.min.js
document.addEventListener('DOMContentLoaded', () => {
  console.log('JS Loaded');
  const body = document.querySelector('body');

  // **********************************************
  // Mobile Nav Open/Close Toggle 
  // ==============================================
  // - Click Event
  // **********************************************
  var mobile_nav_toggle = document.getElementById("js-mobile-nav-toggle");
  var header = document.getElementById("js-tho-header");

  if (mobile_nav_toggle != null && header != null) {
    mobile_nav_toggle.addEventListener('click', function(){
      console.log('clicked');

      if (header.classList.contains('open')) {
        header.classList.remove('open');
      } else {
        header.classList.add('open');
      }
    });
  }
  
  // End of Document ready
});
